import React from "react";
import PropTypes from "prop-types";
import { Popover, Typography, Space } from "antd";
import { UserOutlined } from "@ant-design/icons";

/**
 * Displays the owner passed in
 */
const Owner = ({ owner }) => {
  const popoverTitle = (
    <Typography.Title level={5} style={{ margin: 0 }}>
      <UserOutlined style={{ marginRight: 8, color: "#bfbfbf" }} />
      {owner?.displayName}
    </Typography.Title>
  );

  const popoverContent = (
    <Space direction="vertical" size={0}>
      {owner?.upn && (
        <Space>
          <Typography.Text type="secondary">Main login:</Typography.Text>
          <Typography.Text>{owner.upn}</Typography.Text>
        </Space>
      )}
      {owner?.type && (
        <Space>
          <Typography.Text type="secondary">Resource type:</Typography.Text>
          <Typography.Text>{owner.type}</Typography.Text>
        </Space>
      )}
      {owner?.blocked !== undefined && (
        <Space>
          <Typography.Text type="secondary">Blocked:</Typography.Text>
          <Typography.Text>{owner.blocked ? "true" : "false"}</Typography.Text>
        </Space>
      )}
    </Space>
  );

  return (
    <>
      {owner && (
        <Popover title={popoverTitle} content={popoverContent}>
          <span style={{ cursor: "pointer" }}>{owner.displayName}</span>
        </Popover>
      )}
    </>
  );
};

Owner.propTypes = {
  owner: PropTypes.object.isRequired,
};

export default Owner;
